export default __webpack_public_path__ + "static/media/brain.027c6217.png";